import axios from "axios";

export interface DriverFormDataSubmit {
    userData: {
        email: string;
        userEmail: string;
        password: string;
        profile: {
            firstname: string;
            lastname: string;
            location: {
                province: string;
                city: string;
            };
            gender: 'male' | 'female' | 'other';
            photoUrl: string;
            birthDate: string;
            billingData: {
                documentNumber: string;
                phoneNumber: string;
            };
        };
        documents: {
            name:
            | 'document-front'
            | 'document-back'
            | 'license-front'
            | 'license-back'
            | 'cedula-front'
            | 'cedula-back';
            url: string;
        }[];
    };
    vehicleData: {
        brand: string;
        model: string;
        year: number;
        color: string;
        patent: string;
        type: string;
    };
}


export const useDriverFormService = () => {

    const apiUrl = process.env.REACT_APP_BASE_URL;

    const uploadFile = async (file: File, fileName: string) => {
        try {
            const token = process.env.REACT_APP_API_PHOTOS_TOKEN;
            const endpoint = apiUrl + `/photos/photos`;

            const formData = new FormData();
            formData.append("files", file);

            const { data } = await axios.post(endpoint, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    authorization: token,
                    company: "VIAJAYA",
                },
            });

            if (!data || !Array.isArray(data)) {
                throw new Error("Error uploading file");
            }

            return {
                ...data[0],
                fileName,
            };
        } catch (error: any) {
            throw new Error(error.response?.data?.message || "Unexpected error");
        }
    };

    const submitDriverForm = async (driverData: DriverFormDataSubmit) => {
        try {
            const endpoint = apiUrl + `/auth/VIAJAYA/users/register/form`;

            const response = await axios.post(endpoint, driverData, {
                headers: {
                    "Content-Type": "application/json",
                    company: "VIAJAYA",
                },
            });

            if (response.status === 201) {
                return { success: true };
            }

            if (!response.data || !Array.isArray(response.data)) {
                throw new Error("Error submitting driver form");
            }
            return response.data;
        } catch (error: any) {
            throw new Error(error.response?.data?.message || "Unexpected error");
        }
    };


    return { uploadFile, submitDriverForm };
};

